import medikreditclaimService from '../services/medikreditclaim.service';

const medikreditclaims = {
    namespaced: true,
    state: {},
    actions: {
        //CREATE
        createaccountfromclaim(_, claimId)
        {
            return medikreditclaimService.createaccountfromclaim(claimId);
        },
        //READ
        get(_, params) {
            return medikreditclaimService.get(params.id, params.urlParameters, params.requestId);
        },        
        getreducedview(_, params) {
            return medikreditclaimService.getreducedview(params.id, params.urlParameters, params.requestId);
        },
        //UPDATE

        //DELETE
        delete(_, id) {
            return medikreditclaimService.delete(id);
        },
    },
    getters: {},
    mutations: {},
};

export default medikreditclaims;
